
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import { ResponseType } from "../../../Types/ServicesType/servicesType";
import {
  ClinicianList,
  ConsultationCodeType,
  DoctorLicenseTpe,
  DoctorSaveObjectType,
  MasterTableDataType,
  SearchParamsType,
  TimeSlotSaveType,
  TimeSlotType,
} from "./types";
import instance from "@services/services";
const { MastersApi } = api;
const { clinicId, createdById } = getConstants()
export const getAllDoctor = async (
  params: SearchParamsType
): Promise<
  ResponseType<{ items: MasterTableDataType[]; totalCount: number }>
> => {
  const result = await instance.post(MastersApi.allDoctorsMaster, {
    ...params,
    clinicId,
  });
  return result.data;
};

export const saveMasterData = async ({
  doctorDetails,
  license,
  photo,
  seal,
  sign,
}: {
  doctorDetails: DoctorSaveObjectType;
  license: DoctorLicenseTpe[];
  seal: File | null;
  sign: File | null;
  photo: File | null;
}): Promise<ResponseType<string>> => {
  const formData = new FormData()
  formData.append("doctor",JSON.stringify({...doctorDetails,clinicId,createdById}))
  formData.append("allPostOfficesAndLicenses ",JSON.stringify(license))
  if(seal){formData.append("seal",seal)}
  if(sign){formData.append("sign",sign)}
  if(photo){formData.append("doctorImage",photo)}
  const result = await instance.post(MastersApi.saveDoctorMaster,formData,{
    "headers":{
       "Content-Type": "multipart/form-data"
    }
  })
  return result.data;
};

export const getAllClinician = async (): Promise<
  ResponseType<ClinicianList[]>
> => {
  const result = await instance.get(`${MastersApi.allClinicians}/${clinicId}`);
  return result.data;
};

export const getAllConsultations = async (params: {
  search: string;
  groupId: number;
}): Promise<ResponseType<ConsultationCodeType[]>> => {
  const result = await instance.post(`${MastersApi.doctorCptDropdown}`, {
    ...params,
    clinicId,
  });
  return result.data;
};

export const getDoctorLicense = async (
  doctorId: number
): Promise<ResponseType<DoctorLicenseTpe[]>> => {
  const result = await instance.get(
    `${MastersApi.getDoctorLicense}/${clinicId}?id=${doctorId}`
  );
  return result.data;
};

export const getTimeSlots = async (doctorId: number):Promise<ResponseType<{items:TimeSlotType[],totalCount:number}>> => {
  const result = await instance.get(
    `${MastersApi.getDoctorsTimeslots}/${clinicId}?doctorId=${doctorId}`
  );
  return result.data;
};

export const saveTimeSlot = async (params:TimeSlotSaveType)=>{
     const result = await instance.post(
    `${MastersApi.addDoctorTimeSlot}`,
    {...params,clinicId,createdById}
  );
  return result.data;
}

export const updateDoctorStatus = async (params:{id:number,status:number})=>{
     const result = await instance.post(
    `${MastersApi.updateDoctorStatus}`,
    {...params,clinicId}
  );
  return result.data;
}
export const deleteDoctor = async (params:{ids:number[]})=>{
     const result = await instance.post(
    `${MastersApi.deleteDoctorMaster}`,
    {...params,clinicId}
  );
  return result.data;
}
